import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardHeader,
  CardBody,
  Table,
} from "reactstrap";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import EnquiryModal from "models/enquiries.modal";
import tutorsMapModal from "models/mapdata.modal";
import AcademicModal from "models/academic.modal";
// import { IoMan } from "react-icons/io5";
import ReactDOMServer from "react-dom/server";
import { useLocation, useParams } from "react-router-dom";
import Select from "react-select";
import { toast } from "lib/helper";
// Fix marker icon issue with Leaflet
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

const ShortlistTutors = () => {
  const params = useParams();
  console.log("parmscheck", params);
  const [value, setValue] = useState(0);
  const [radiusvalue, setRadiusvalue] = useState(0);
  const [enqlist, setEnqlist] = useState();

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const GetEnqurieslist = async () => {
    EnquiryModal.QualifiedEnquirylimt()
      .then((responce) => {
        setEnqlist(responce?.data);
        
      })
      .catch((error) => {
        console.log("error shortlist", error);
      });
  };
  useEffect(() => {
    GetEnqurieslist();
    Acadamic();
  }, []);

  const [acadamicdata, setAcadamicdata] = useState();
  const Acadamic = async () => {
    await AcademicModal.list()
      .then((responce) => {
        setAcadamicdata(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const [boarddata, setBoarddata] = useState();

  const Board = async (id) => {
    setBoarddata("")
if(id){
    await AcademicModal.listbyidAcademicSubCategory(id)
      .then((responce) => {
        
        setBoarddata(responce?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });}
      else{
        setBoarddata("")
      }
  };

  const [classdata, setClassdata] = useState();
  const Class = async (id) => {
    await AcademicModal.listbyidAcademicSubCategory(id)
      .then((responce) => {
        setClassdata(responce?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const [subjectdata, setSubjectdata] = useState();
  const Subject = async (id) => {
    if (id) {
      await AcademicModal.listbyidAcademicSubCategory(id)
        .then((responce) => {
          setSubjectdata(responce?.data?.data);
        })
        .catch((error) => {
          console.log("error", error);
        });
    } else {
      setSubjectdata("");
    }
  };
  const [finaldata, setFinaldata] = useState();
  const GetData = async (event) => {
    event.preventDefault();

    const form = new FormData(event.target);
    const params = new URLSearchParams();

   
    for (const [key, value] of form.entries()) {
      if (key === "english_fluency" || key === "radius") {
       
        if (Number(value) > 0) {
          params.append(key, value);
        }
      } else if (value.trim()) {
        
        params.append(key, value);
      }
    }
  

    try {
      const response = await tutorsMapModal.get(params);
      setFinaldata(response);
    } catch (error) {
      setFinaldata("");
      toast( error?.response?.data?.message,"warning" );
    }
  };
  const locations = finaldata?.data?.map((item) => ({
    lat: item?.tutorApi_teachinglocation?.lat,
    long: item?.tutorApi_teachinglocation?.long,
    city: item?.tutorApi_teachinglocation?.city,
    state: item?.tutorApi_teachinglocation?.state,
    firstName: item?.first_name,
    lastName: item?.last_name,
    mobile: item?.username,
  }));
  console.log("finaldata", finaldata);
  const createCustomIcon = () =>
    L.divIcon({
      html: `<div style="font-size: 24px; color: blue;"><span>${ReactDOMServer.renderToString(
        // <IoMan />
      )}</span></div>`,
      className: "custom-div-icon", // Optional: Add custom styles
      iconAnchor: [12, 12], // Adjust anchor point if needed
      popupAnchor: [0, -12], // Adjust popup position
    });

  const [selectedValueselectedValue, setSelectedValue] = useState(
    params?.id || ""
  );

  useEffect(() => {
    if (params?.id) {
      setSelectedValue(params.id); // Update state when params.id changes
    }
  }, [params]);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const options = [
    {
      value: "Adaptable & Reliable",
      label: "Adaptable & Reliable",
    },
    {
      value: "Demanding or Money-Focused",
      label: "Demanding or Money-Focused",
    },
    {
      value: "Rigid or Difficult to Manage",
      label: "Rigid or Difficult to Manage",
    },
    {
      value: "Premium Client Ready",
      label: "Premium Client Ready",
    },
    {
      value: "Not Suitable for Premium Clients",
      label: "Not Suitable for Premium Clients",
    },
    {
      value: "Inconsistent or Unreliable",
      label: "Inconsistent or Unreliable",
    },
    {
      value: "Underconfident or Needs Improvement",
      label: "Underconfident or Needs Improvement",
    },
    {
      value: "Inactive or Seeking Classes",
      label: "Inactive or Seeking Classes",
    },
    {
      value: "Dedicated & Professional",
      label: "Dedicated & Professional",
    },
    {
      value: "Patient & Empathetic",
      label: "Patient & Empathetic",
    },
  ];
  console.log("data",finaldata)
  return (
    <Container className="px-4 py-7">
      <div className="col p-3">
        <Card className="shadow">
          <CardHeader className="border-0 d-flex justify-content-between ">
            <h3 className="mb-0">Shortlist Tutors</h3>
          </CardHeader>
          <CardBody>
            <Row>
              <Col md="6">
                <form onSubmit={GetData}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="icse">Select Enquiry</Label>
                        <Input
                          type="select"
                          name="enquiry_id"
                          id="icse"
                          required
                          value={selectedValueselectedValue}
                          onChange={(e)=>{setSelectedValue(e.target.value)}}
                        >
                          <option value="">-- select --</option>
                          {enqlist?.map((item, index) => {
                            return (
                              <option value={item?.id} key={index}>
                                {item?.studentApi_parent?.auth_user?.first_name}{" "}
                                {item?.studentApi_parent?.auth_user?.last_name}{" "}
                                {`(${item?.studentApi_parent?.auth_user?.username})`}
                              </option>
                            );
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="badge">Select Status</Label>
                        <Select options={options} name="status[]" isMulti />
                        
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row form>
                    <Col md={boarddata ? 6 : 12}>
                      <FormGroup>
                        <Label for="status">Academic</Label>
                        <Input
                          type="select"
                          id="status"
                          onChange={(e) => {
                            setClassdata("");
                            setSubjectdata("");
                            Board(e.target.value);
                          }}
                        >
                          <option value="">-- select --</option>
                          {acadamicdata?.map((item, index) => {
                            return (
                              <option value={item?.id} key={index}>
                                {item?.name}
                              </option>
                            );
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                    {boarddata && (
                      <Col md={6}>
                        <FormGroup>
                          <Label for="gender">Board</Label>
                          <Input
                            type="select"
                            id="gender"
                            onChange={(e) => {
                              Class(e.target.value);
                            }}
                          >
                            <option value="">-- select --</option>
                            {boarddata?.map((item, index) => {
                              return (
                                <option key={index} value={item?.id}>
                                  {item?.name}
                                </option>
                              );
                            })}
                          </Input>
                        </FormGroup>
                      </Col>
                    )}
                  </Row>
                  <Row form>
                    {classdata && (
                      <Col md={subjectdata ? 6 : 12}>
                        <FormGroup>
                          <Label for="macro">Class</Label>
                          <Input
                            type="select"
                           
                            id="macro"
                            onChange={(e) => {
                              setSubjectdata("");
                              Subject(e.target.value);
                            }}
                          >
                            <option value="">Select</option>
                            {classdata?.map((item, index) => {
                              return (
                                <option value={item.id} key={index}>
                                  {item?.name}
                                </option>
                              );
                            })}
                          </Input>
                        </FormGroup>
                      </Col>
                    )}
                    {subjectdata && (
                      <Col md={6}>
                        <FormGroup>
                          <Label for="subMacro">Subject</Label>
                          <Input type="select" name="subject" id="subMacro">
                            <option value="">Select</option>
                            {subjectdata?.map((item, index) => {
                              return (
                                <option key={index} value={item.id}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </Input>
                        </FormGroup>
                      </Col>
                    )}
                  </Row>
                  <Row form>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="macro">Gender</Label>
                        <Input type="select" name="gender" id="macro">
                          <option value="">Select</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="subMacro">Badge/Level</Label>
                        <Input type="select" name="badge" id="subMacro">
                          <option value="">Select</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row form>
                    <Col md={6}>
                      <FormGroup className="w-full">
                        <Label for="englishFluency">{`English Fluency(${value})`}</Label>
                        <input
                          type="range"
                          name="english_fluency"
                          id="englishFluency"
                          min="0"
                          max="10"
                          value={value}
                          onChange={handleChange}
                          className="w-full"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="radius">Radius ({radiusvalue} Km)</Label>
                        <Input
                          type="range"
                          name="radius"
                          id="radius"
                          min="0"
                          max="40"
                          defaultValue={radiusvalue}
                          onChange={(e) => {
                            setRadiusvalue(e.target.value);
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button type="submit" className="mb-2">
                    Apply Filters
                  </Button>
                </form>
              </Col>

              <Col md="6">
                <div style={{ height: "500px" }}>
                  <MapContainer
                    center={[23.2599, 77.4126]} // Default center
                    zoom={5} // Adjust zoom level as needed
                    style={{ height: "100%", width: "100%" }}
                  >
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    />
                    {locations?.map(
                      (location, index) =>
                        location.lat &&
                        location.long && ( // Ensure lat and long exist
                          <Marker
                            key={index}
                            position={[location.lat, location.long]}
                          >
                            <Popup>
                              <strong
                                style={{ color: "blue" }}
                              >{`${location.firstName} ${location.lastName}`}</strong>
                              <br />
                              <span style={{ color: "green" }}>
                                mobile no:{location.mobile}
                              </span>
                              <br />
                              {location.city}, {location.state}
                            </Popup>
                          </Marker>
                        )
                    )}
                  </MapContainer>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <div style={{ height: "500px" }}>
                  <MapContainer
                    center={[23.2599, 77.4126]} // Default center
                    zoom={5} // Adjust zoom level as needed
                    style={{ height: "100%", width: "100%" }}
                  >
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    />
                    {locations?.map(
                      (location, index) =>
                        location.lat &&
                        location.long && ( // Ensure lat and long exist
                          <Marker
                            key={index}
                            position={[location.lat, location.long]}
                            icon={createCustomIcon()}
                          >
                            <Popup>
                              <strong
                                style={{ color: "blue" }}
                              >{`${location.firstName} ${location.lastName}`}</strong>
                              <br />
                              <span style={{ color: "green" }}>
                                mobile no:{location.mobile}
                              </span>
                              <br />
                              {location.city}, {location.state}
                            </Popup>
                          </Marker>
                        )
                    )}
                  </MapContainer>
                </div>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <Table striped>
                  <thead>
                    <tr>
                      <th>Tutor</th>
                      <th>Mobile No.</th>
                      <th>Age</th>
                      <th>Distance</th>
                      <th>Badge</th>
                      <th>Per Hour</th>
                    </tr>
                  </thead>
                  <tbody>
                    {finaldata?.data?.map((item, index) => {
                      const calculateAge = (dob) => {
                        const birthDate = new Date(dob); // Parse the date string
                        const today = new Date(); // Get today's date

                        let age = today.getFullYear() - birthDate.getFullYear();
                        const monthDifference =
                          today.getMonth() - birthDate.getMonth();

                        // Adjust age if the birth month hasn't been reached or it's the current month and the day hasn't occurred yet
                        if (
                          monthDifference < 0 ||
                          (monthDifference === 0 &&
                            today.getDate() < birthDate.getDate())
                        ) {
                          age--;
                        }

                        return age;
                      };

                      const age = item?.tutorApi_personalinformation?.dob
                        ? calculateAge(item.tutorApi_personalinformation.dob)
                        : "N/A"; // Handle missing DOB
                      return (
                        <tr>
                          <td>
                            {item?.first_name} {item?.last_name}
                          </td>
                          <td>{item?.username}</td>
                          <td>{age}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      );
                    })}

                    {/* Add more rows as needed */}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </Container>
  );
};

export default ShortlistTutors;
